import { Badge, MantineColor } from '@mantine/core';
import Select, { components } from 'react-select';
import { StylesConfig } from 'react-select/src/styles';

interface Option {
	value: string;
	label: string;
	color: MantineColor;
}

type BadgeSelectProps = {
	options: Option[],
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onChange: ( selectedOption: any ) => void
	value: string,
	containerRef?: React.RefObject<HTMLElement>,
	label?: string
};

const styles: StylesConfig = {
	menu: provided => ( {
		...provided,
		backgroundColor: 'var(--color-bg-container)',
		border: '1px solid var(--color-outline-default)',
		boxShadow: '0 2px 4px var(--color-shadow-md)'
	} ),
	menuList: provided => ( {
		...provided,
		padding: 4,
		backgroundColor: 'var(--color-bg-container)'
	} ),
	option: ( provided, state ) => ( {
		...provided,
		'backgroundColor': state.isFocused ? 'var(--color-bg-container-hover)' : 'var(--color-bg-container)',
		'cursor': 'pointer',
		'&:not(:last-child)': {
			borderBottom: '1px solid var(--color-outline-default)'
		},
		'&:active': {
			backgroundColor: 'var(--color-bg-container-hover)'
		},
		'padding': '5px'
	} ),
	singleValue: provided => ( {
		...provided,
		backgroundColor: 'transparent',
		padding: 0
	} ),
	control: provided => ( {
		...provided,
		backgroundColor: 'transparent',
		padding: '0',
		border: 'none',
		boxShadow: 'none',
		cursor: 'pointer'
	} ),
	indicatorSeparator: provided => ( {
		...provided,
		display: 'none'
	} )
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const BadgeOption = ( props: any ) => {
	const { data } = props;
	return (
		<components.Option {...props}>
			<Badge variant="light" radius="xs" size="md" color={data.color}>
				{data.label}
			</Badge>
		</components.Option>
	);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const BadgeSingleValue = ( props: any ) => {
	const { data } = props;
	return (
		<components.SingleValue {...props}>
			<Badge variant="light" radius="xs" size="md" color={data.color}>
				{data.label}
			</Badge>
		</components.SingleValue>
	);
};

const BadgeSelect: React.FC<BadgeSelectProps> = ( {
	options,
	onChange,
	value,
	containerRef,
	label
}: BadgeSelectProps ) => (
	<Select
		value={options.find( option => option.value === value )}
		options={options}
		styles={styles}
		components={{ Option: BadgeOption, SingleValue: BadgeSingleValue }}
		onChange={onChange}
		placeholder="Select a color..."
		menuPortalTarget={containerRef?.current}
		menuShouldBlockScroll
		menuPosition="fixed"
		aria-label={label || 'BadgeSelect'}
	/>
);

export default BadgeSelect;
